import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ibans, (iban, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "grid grid-cols-[repeat(2,_minmax(0,_1fr))_max-content] gap-4 mb-3"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Field, {
            "label-visible": false,
            modelValue: iban.iban,
            "onUpdate:modelValue": ($event: any) => ((iban.iban) = $event),
            placeholder: "IBAN",
            errors: _ctx.getErrors(i,'iban')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Field, {
            "label-visible": false,
            modelValue: iban.descrizione,
            "onUpdate:modelValue": ($event: any) => ((iban.descrizione) = $event),
            placeholder: "Descrizione",
            errors: _ctx.getErrors(i,'descrizione')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_NextButton, {
            variant: "outline-secondary",
            onClick: ($event: any) => (_ctx.removeIban(i)),
            class: "col flex justify-center items-center h-8 w-8"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "icon-x" }, null, -1)
            ])),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_NextButton, {
        variant: "primary",
        onClick: _ctx.addIban,
        class: "col flex justify-center items-center h-8 w-8"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "icon-croce_quadrata" }, null, -1)
        ])),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}